import { render, staticRenderFns } from "./x-user-avatar.vue?vue&type=template&id=647ee3bd&scoped=true&"
import script from "./x-user-avatar.vue?vue&type=script&lang=js&"
export * from "./x-user-avatar.vue?vue&type=script&lang=js&"
import style0 from "./x-user-avatar.vue?vue&type=style&index=0&id=647ee3bd&lang=scss&scoped=true&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "647ee3bd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/anatec/wesave/wesave-conseil-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('647ee3bd', component.options)
    } else {
      api.reload('647ee3bd', component.options)
    }
    module.hot.accept("./x-user-avatar.vue?vue&type=template&id=647ee3bd&scoped=true&", function () {
      api.rerender('647ee3bd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/controls/x-user-avatar.vue"
export default component.exports